// extracted by mini-css-extract-plugin
export default {"ContainerPage":"error_ContainerPage__wRTi3","IconCantCall":"error_IconCantCall__4tjn5","TextCantCall":"error_TextCantCall__vRhFZ"};